import { BookOpenIcon } from '@phosphor-icons/react';
import { Dialog, DialogContent } from '../../../components/ui/dialog';
import { Drawer, DrawerContent } from '../../../components/ui/drawer';
import { Button } from '../../../components/ui/button';
import ModalCloseButton from '../../../components/generic/ModalCloseButton';
import { useIsTablet } from '../../../lib/useIsTablet';

const GuidelinesModal = ({ open, onClose, guidelines }) => {
  const isTablet = useIsTablet();

  const renderBody = () => (
    <div className="flex flex-col items-center gap-4">
      <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[var(--q3-success-light)]">
        <BookOpenIcon size={26} className="text-[var(--q3-success-normal)]" />
      </div>
      <div className="flex flex-col gap-1">
        <h2 className="text-xl font-bold text-[var(--q3-neutral-default)]">Guidelines for a faster Approval</h2>
        <p className="text-[15px] text-[var(--q3-neutral-light)]">Please read these guidelines carefully</p>
      </div>

      <div
        className="w-full text-left text-[14px] text-[var(--q3-neutral-default)] leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-2 [&_a]:text-[var(--q3-blue-normal)] [&_a]:underline"
        dangerouslySetInnerHTML={{ __html: guidelines || '' }}
      />

      <Button
        className="w-full rounded-full mt-2 bg-[var(--q3-blue-normal)] hover:scale-100 hover:bg-[var(--q3-blue-dark)] duration-200"
        onClick={onClose}
      >
        Okay I understood
      </Button>
    </div>
  );

  if (isTablet) {
    return (
      <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
        <DialogContent className="max-w-lg text-center" showCloseButton={false}>
          <ModalCloseButton onClick={onClose} />
          {renderBody()}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DrawerContent showCloseButton={false} className="px-4 pb-6 max-h-[90vh] text-center">
        <ModalCloseButton onClick={onClose} />
        <div className="overflow-y-auto pt-4">{renderBody()}</div>
      </DrawerContent>
    </Drawer>
  );
};

export default GuidelinesModal;
